export type WorkspaceViewSort = {
  column?: string;
  direction?: WorkspaceViewSortDirection;
};

export enum WorkspaceViewSortDirection {
  asc = 'asc',
  desc = 'desc',
}
